var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-cell selected-tiem"},[_c('ejs-radiobutton',{attrs:{"name":"custom","css-class":"e-primary"},on:{"change":_vm.selectTemplate},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }